import React from 'react'
import {useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Form, Typography} from 'antd'
import {useInjection} from 'dna-react-ioc'
import {withTitle} from '@/router/utils'
import {ROUTES} from '@/router/routes'
import {Button, Card, Input} from '@/components'
import {EMAIL_TO_RESET, SUBMIT_RESET} from '@/constants/playwright-ids'
import {IValidateEmailStore} from './IValidateEmailStore'

import styles from './styles.scss'

export const ValidateEmailStoreSymbol = Symbol('ValidateEmailStore')

const ValidateEmail = observer(() => {
    const {t} = useTranslation()
    const [form] = Form.useForm()
    const store = useInjection<IValidateEmailStore>(ValidateEmailStoreSymbol)
    const {isLoading, validateEmail} = store

    const onFinish = (values) => {
        validateEmail(values.email?.toLowerCase())
    }

    const formId = 'validate-email'

    return (
        <div className={styles.resetCard}>
            <Card title={t('ValidateEmail.title')}>
                <div>{t('ValidateEmail.text')}</div>
                <br />
                <Form
                    form={form}
                    id={formId}
                    layout='vertical'
                    requiredMark={false}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label={t('ValidateEmail.email')}
                        name='email'
                        rules={[
                            {required: true, message: t('ValidateEmail.emailRequired')},
                            {
                                type: 'email',
                                message: t('ValidateEmail.emailInvalid')
                            }
                        ]}
                    >
                        <Input
                            placeholder={t('ValidateEmail.email')}
                            data-test-id={EMAIL_TO_RESET}
                        />
                    </Form.Item>
                    <Form.Item key={'submit'} className={styles.buttonHolder}>
                        <Button
                            form={formId}
                            type={'primary'}
                            htmlType={'submit'}
                            className={styles.submit}
                            loading={isLoading}
                            data-test-id={SUBMIT_RESET}
                        >
                            {t('ValidateEmail.submit')}
                        </Button>
                    </Form.Item>

                    <div className={styles.footer}>
                        <Typography.Text className={styles.question} type={'secondary'}>
                            {t('ValidateEmail.alreadyHaveAnAccount')}
                        </Typography.Text>
                        <Link to={ROUTES.login}>{t('ValidateEmail.login')}</Link>
                    </div>
                </Form>
            </Card>
        </div>
    )
})

export default withTitle(ValidateEmail)
